import { render, staticRenderFns } from "./querySalesArrearsReportList.vue?vue&type=template&id=6c7a0ece"
import script from "./querySalesArrearsReportList.vue?vue&type=script&lang=js"
export * from "./querySalesArrearsReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports